// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2H6j-","savePackageButton":"ClientWallet_savePackageButton__3nmJ8"};